import { createStaticReducer } from '../utils/redux/createStaticReducer';

export const btpFlightRkActiveReducer = createStaticReducer<boolean>(false);
